<template>
  <div class="encoder">
    <div class="banner">
      <img
        src="@/assets/production/production_banner.jpg"
        class="img-responsive visible-sm visible-md visible-lg"
        alt="banner"
      />
      <img
        src="@/assets/production/production_banner_m.png"
        class="img-responsive visible-xs"
        alt="banner"
      />
      <dl class="visible-sm visible-md visible-lg">
        <dd>产品中心</dd>
        <dt>production</dt>
      </dl>
    </div>
    <div class="container marB40">
      <hgroup class="hgroup-title text-center">
        <h2 class="color333 marT10">编转码系统</h2>
        <span></span>
      </hgroup>
      <ul class="nav nav-tabs">
        <li role="presentation" :class="{ active: currentIndex === 1 }">
          <a @click="showbtn(1, $event)">实时编转码</a>
        </li>
        <li role="presentation" :class="{ active: currentIndex === 2 }">
          <a @click="showbtn(2, $event)">离线编转码</a>
        </li>
      </ul>
      <div class="tab-content" style="height: 100px">
        <!--实时转码-->
        <div class="" id="realTime" v-show="showData === 1">
          <div class="system-wrap">
            <div class="layout-header">
              <span class="layout-title marL30">系统概述</span>
            </div>
            <div class="layout-p">
              <p class="tIndent2">
                BES实时编转码系统，可实现对各种视频实时信号、实时流的高质量压缩转换，可应用于数字电视直播、IPTV直播、OTT直播、移动视频直播、网络视频直播等领域，可满足机顶盒、智能电视、电脑、平板、手机等多屏同播的直播需求。
              </p>
              <p class="tIndent2">
                BES系列实时视音频编码器具有多种密度规格型号，可满足多种客户应用场景。
              </p>
              <p class="tIndent2">
                15年视频Codec算法经验，自研smart squeezer
                优化算法，采用多种业界优化技术，可实现出色的画质效果，可支持4K/8K
                、10bit、HDR、BT2020、60FPS优质画质效果。
              </p>
              <!--<p class="tIndent2">主要型号:</p>
                    <p class="tIndent2">BES3000：BES3015S（2路高标清）、BES3015M（4路高标清）</p>
                    <p class="tIndent2">BES5000系列：BES5015S（5路高清）、BES5015M（8路高清）、BES5025M（15路高清）、BES5025H（30路高清）</p>-->
            </div>
            <div class="clearfix">
              <!--<img src="@/assets/production/encoder/system_img.png" class="img-responsive pull-right"/>--><img
                src="@/assets/production/encoder/1.png"
                class="img-responsive pull-right"
              />
            </div>
          </div>
          <div class="advantage-wrap">
            <div class="layout-header">
              <span class="layout-title marL30">产品优势</span>
            </div>
            <div class="visible-lg visible-md visible-sm clearfix">
              <!--left-->
              <div class="adv-left">
                <div class="adv_item">
                  <i class="icon1 pull-left"></i>
                  <div class="item_right pull-left">
                    <h3>高质量</h3>
                    <p>同码率下出色的视频压缩质量</p>
                  </div>
                </div>
                <div class="adv_item">
                  <i class="icon3 pull-left"></i>
                  <div class="item_right pull-left">
                    <h3>高性能</h3>
                    <p>GPU硬件加速，单机可高达百倍速高清转码能力</p>
                  </div>
                </div>
                <div class="adv_item">
                  <i class="icon5 pull-left"></i>
                  <div class="item_right pull-left">
                    <h3>多接口</h3>
                    <p>支持AV/SDI/HDMI/ASI/IP等多种接口，支持SDI解码输出</p>
                  </div>
                </div>
                <div class="adv_item">
                  <i class="icon7 pull-left"></i>
                  <div class="item_right pull-left">
                    <h3>多协议</h3>
                    <p>支持RTMP/UDP-TS/HLS/HDS/HTTP-Flv/HTTP-TS等协议</p>
                  </div>
                </div>
              </div>
              <!--right-->
              <div class="adv-right">
                <div class="adv_item">
                  <i class="icon2 pull-left"></i>
                  <div class="item_right pull-left">
                    <h3>多屏输出</h3>
                    <p>支持输出至PC/TV/Phone/PAD，支持多码率逐帧对齐</p>
                  </div>
                </div>
                <div class="adv_item">
                  <i class="icon4 pull-left"></i>
                  <div class="item_right pull-left">
                    <h3>简单易用</h3>
                    <p>简捷易用的管理系统，丰富易用的HTTP RESTful API</p>
                  </div>
                </div>
                <div class="adv_item">
                  <i class="icon6 pull-left"></i>
                  <div class="item_right pull-left">
                    <h3>集群架构</h3>
                    <p>支持集群架，支持Push/Pull输入</p>
                  </div>
                </div>
                <div class="adv_item">
                  <i class="icon8 pull-left"></i>
                  <div class="item_right pull-left">
                    <h3>高可靠性</h3>
                    <p>24*365稳定工作</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="visible-xs">
              <div class="adv_item">
                <i class="icon1 pull-left"></i>
                <div class="item_right pull-left">
                  <h3>高质量</h3>
                  <p>同码率下出色的视频压缩质量</p>
                </div>
              </div>
              <div class="adv_item">
                <i class="icon3 pull-left"></i>
                <div class="item_right pull-left">
                  <h3>高性能</h3>
                  <p>GPU硬件加速，单机可高达百倍速高清转码能力</p>
                </div>
              </div>
              <div class="adv_item">
                <i class="icon5 pull-left"></i>
                <div class="item_right pull-left">
                  <h3>多接口</h3>
                  <p>支持AV/SDI/HDMI/ASI/IP等多种接口，支持SDI解码输出</p>
                </div>
              </div>
              <div class="adv_item">
                <i class="icon7 pull-left"></i>
                <div class="item_right pull-left">
                  <h3>多协议</h3>
                  <p>支持RTMP/UDP-TS/HLS/HDS/HTTP-Flv/HTTP-TS等协议</p>
                </div>
              </div>
              <div class="adv_item">
                <i class="icon2 pull-left"></i>
                <div class="item_right pull-left">
                  <h3>多屏输出</h3>
                  <p>支持输出至PC/TV/Phone/PAD，支持多码率逐帧对齐</p>
                </div>
              </div>
              <div class="adv_item">
                <i class="icon4 pull-left"></i>
                <div class="item_right pull-left">
                  <h3>简单易用</h3>
                  <p>简捷易用的管理系统，丰富易用的HTTP RESTful API</p>
                </div>
              </div>
              <div class="adv_item">
                <i class="icon6 pull-left"></i>
                <div class="item_right pull-left">
                  <h3>集群架构</h3>
                  <p>支持集群架，支持Push/Pull输入</p>
                </div>
              </div>
              <div class="adv_item">
                <i class="icon8 pull-left"></i>
                <div class="item_right pull-left">
                  <h3>高可靠性</h3>
                  <p>24*365稳定工作</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--离线转码-->
        <div class="" id="offline" v-show="showData === 2">
          <div class="system-wrap">
            <div class="layout-header">
              <span class="layout-title marL30">系统概述</span>
            </div>
            <p class="layout-p marT30 tIndent2">
              BTS离线编转码系统，可实现对所有主流视频文件格式的高质量、高速压缩转换，可应用于互动电视、IPTV点播、OTT点播、移动视频点播、网络视频点播等领域，可满足机顶盒、智能电视、电脑、平板、手机等多屏互动点播需求。
            </p>
            <div class="clearfix">
              <img
                src="@/assets/production/encoder/offline.png"
                class="img-responsive pull-right"
              />
            </div>
          </div>
          <div class="advantage-wrap offline">
            <div class="layout-header">
              <span class="layout-title marL30">产品优势</span>
            </div>
            <div class="visible-lg visible-md visible-sm clearfix">
              <!--left-->
              <div class="adv-left">
                <div class="adv_item">
                  <i class="icon1 pull-left"></i>
                  <div class="item_right pull-left">
                    <h3>高质量</h3>
                    <p>同码率下出色的视频压缩质量</p>
                  </div>
                </div>
                <div class="adv_item">
                  <i class="icon3 pull-left"></i>
                  <div class="item_right pull-left">
                    <h3>高性能</h3>
                    <p>GPU硬件加速，单机可高达百倍速高清转码能力</p>
                  </div>
                </div>
                <div class="adv_item">
                  <i class="icon5 pull-left"></i>
                  <div class="item_right pull-left">
                    <h3>多格式</h3>
                    <p>支持上百种视频格式输入，支持NFS/FTP/HTTP等多种输入</p>
                  </div>
                </div>
                <div class="adv_item">
                  <i class="icon7 pull-left"></i>
                  <div class="item_right pull-left">
                    <h3>简单易用</h3>
                    <p>简捷易用的管理系统，丰富易用的HTTP RESTful API</p>
                  </div>
                </div>
              </div>
              <!--right-->
              <div class="adv-right">
                <div class="adv_item">
                  <i class="icon2 pull-left"></i>
                  <div class="item_right pull-left">
                    <h3>多屏输出</h3>
                    <p>支持输出至PC/TV/Phone/PAD，支持多码率逐帧对齐</p>
                  </div>
                </div>
                <div class="adv_item">
                  <i class="icon4 pull-left"></i>
                  <div class="item_right pull-left">
                    <h3>超大集群</h3>
                    <p>>1000台集群部署能力，支持节点设备热部署</p>
                  </div>
                </div>
                <div class="adv_item">
                  <i class="icon6 pull-left"></i>
                  <div class="item_right pull-left">
                    <h3>自动转码</h3>
                    <p>可监控热文件夹并配置转码模板</p>
                  </div>
                </div>
                <div class="adv_item">
                  <i class="icon8 pull-left"></i>
                  <div class="item_right pull-left">
                    <h3>高可靠性</h3>
                    <p>24*365稳定工作</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="visible-xs">
              <div class="adv_item">
                <i class="icon1 pull-left"></i>
                <div class="item_right pull-left">
                  <h3>高质量</h3>
                  <p>同码率下出色的视频压缩质量</p>
                </div>
              </div>
              <div class="adv_item">
                <i class="icon3 pull-left"></i>
                <div class="item_right pull-left">
                  <h3>高性能</h3>
                  <p>GPU硬件加速，单机可高达百倍速高清转码能力</p>
                </div>
              </div>
              <div class="adv_item">
                <i class="icon5 pull-left"></i>
                <div class="item_right pull-left">
                  <h3>多接口</h3>
                  <p>支持AV/SDI/HDMI/ASI/IP等多种接口，支持SDI解码输出</p>
                </div>
              </div>
              <div class="adv_item">
                <i class="icon7 pull-left"></i>
                <div class="item_right pull-left">
                  <h3>多协议</h3>
                  <p>输入输出支持RTMP/UDP-TS/HLS/HDS/HTTP-Flv/HTTP-TS等</p>
                </div>
              </div>
              <div class="adv_item">
                <i class="icon2 pull-left"></i>
                <div class="item_right pull-left">
                  <h3>多屏输出</h3>
                  <p>支持输出至PC/TV/Phone/PAD，支持多码率逐帧对齐</p>
                </div>
              </div>
              <div class="adv_item">
                <i class="icon4 pull-left"></i>
                <div class="item_right pull-left">
                  <h3>简单易用</h3>
                  <p>简捷易用的管理系统，丰富易用的HTTP RESTful API</p>
                </div>
              </div>
              <div class="adv_item">
                <i class="icon6 pull-left"></i>
                <div class="item_right pull-left">
                  <h3>集群架构</h3>
                  <p>支持集群架，支持Push/Pull输入</p>
                </div>
              </div>
              <div class="adv_item">
                <i class="icon8 pull-left"></i>
                <div class="item_right pull-left">
                  <h3>高可靠性</h3>
                  <p>24*365稳定工作</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      showData: 1,
      currentIndex: 1
    }
  },
  mounted () {

  },
  methods: {
    showbtn (type, e) {
      this.showData = type
      this.currentIndex = type
    }
  }
}
</script>

<style lang="less">
.nav-tabs {
  border-bottom: none;
}
</style>